// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

import { RebateContractorTypeAhead } from "./RebateContractorTypeAhead";

export class RebateReassignment {

    public static Init() {
        $("input[id=ApplicationInformation_ReassignRebateTypeId]").on("change", () => {
            this.SetRebatePaymentSectionCustomer();
            var rebateAssignmentType = $("input[id=ApplicationInformation_ReassignRebateTypeId]:checked").val();
            if (rebateAssignmentType == 'None' ||
                rebateAssignmentType == 'PropertyOwner' ||
                rebateAssignmentType == 'MailingAddress' ||
                rebateAssignmentType == 'MailingAddressFromCIS' ||
                rebateAssignmentType == 'PaymentReassignment' ||
                rebateAssignmentType == 'Contractor') {
                this.ClearRebatePayeeFields();
                RebateContractorTypeAhead.ResetContractorLookup();
            }
        });

        RebateContractorTypeAhead.Init("ApplicationInformation_RebatePayeeContractorCompanyTypeahead");

        $("#rebate-payment-div").css("display", "none").removeClass("d-none");
        $("#rebate-payment-div").find(".d-none").css("display", "none").removeClass("d-none");
    }


    public static SetRebatePaymentSectionCustomer() {

        var rebateAssignmentType = $("input[id=ApplicationInformation_ReassignRebateTypeId]:checked").val();
        if (rebateAssignmentType == 'None' || rebateAssignmentType == 'PropertyOwner') {
            this.HideRebatePaymentSection();
            this.ClearRebatePayeeFields();
        } else if (rebateAssignmentType == 'MailingAddress') {
            this.EnableDisableRebatePayeeAddress(true);
            this.EnableDisableRebatePayeeName(false);
            this.ShowRebatePaymentSection();
            this.ShowRebateAddressOnly();
        } else if (rebateAssignmentType == 'MailingAddressFromCIS') {
            this.EnableDisableRebatePayeeAddress(true);
            this.EnableDisableRebatePayeeName(false);
            this.ShowRebatePaymentSection();
            this.ShowRebateCISAddressOnly();
        } else if (rebateAssignmentType == 'PaymentReassignment') {
            this.EnableDisableRebatePayeeAddress(true);
            this.EnableDisableRebatePayeeName(true);
            this.ShowRebatePaymentSection();
            this.ShowRebateNameAddress();
        } else if (rebateAssignmentType == 'PremiseAddress') {
            this.EnableDisableRebatePayeeAddress(true);
            this.EnableDisableRebatePayeeName(true);
            this.CopyPremiseAddressToPaymentSection();
            this.ShowRebatePaymentSection();
            this.ShowRebateNameAddress();
        } else if (rebateAssignmentType == 'ApplicationOwner') {
            this.EnableDisableRebatePayeeAddress(true);
            this.EnableDisableRebatePayeeName(true);
            this.CopyContractorAddressToPaymentSection();
            this.ShowRebatePaymentSection();
            this.ShowRebateNameAddress();
        } else if (rebateAssignmentType == 'Contractor') {
            this.ShowRebatePaymentSection();
            this.EnableDisableRebatePayeeName(false);
            this.EnableDisableRebatePayeeAddress(false);
            this.ShowContractorLookup();
        }
        else {
            this.HideRebatePaymentSection();
        }
    }

    //Hide the entire rebate payment section
    private static HideRebatePaymentSection() {
        if ($("#rebate-payment-div").hasClass('active')) {
            $("#rebate-payment-div").toggleClass('active');
            $("#rebate-payment-div").slideToggle("slow");
        }
    }

    //Show the entire payment section
    private static ShowRebatePaymentSection() {
        if (!$("#rebate-payment-div").hasClass('active')) {
            $("#rebate-payment-div").toggleClass('active');
            $("#rebate-payment-div").slideToggle("slow");
        }
    }

    private static ShowRebateNameAddress() {
        //show name
        if (!$("#rebate-payment-name-div").hasClass('active')) {
            $("#rebate-payment-name-div").toggleClass('active');
            $("#rebate-payment-name-div").slideToggle("slow");
        }

        //Show address
        if (!$("#rebate-payment-address-div").hasClass('active')) {
            $("#rebate-payment-address-div").toggleClass('active');
            $("#rebate-payment-address-div").slideToggle("slow");
        }

        //Hide CIS address
        if ($("#rebate-payment-cisaddress-div").hasClass('active')) {
            $("#rebate-payment-cisaddress-div").toggleClass('active');
            $("#rebate-payment-cisaddress-div").slideToggle("slow");
        }

        //hide contractory
        if ($("#rebate-payment-contractor-div").hasClass('active')) {
            $("#rebate-payment-contractor-div").toggleClass('active');
            $("#rebate-payment-contractor-div").slideToggle("slow");
        }
    }

    private static ShowRebateAddressOnly() {

        //show address
        if (!$("#rebate-payment-address-div").hasClass('active')) {
            $("#rebate-payment-address-div").toggleClass('active');
            $("#rebate-payment-address-div").slideToggle("slow");
        }

        //hide cis address
        if ($("#rebate-payment-cisaddress-div").hasClass('active')) {
            $("#rebate-payment-cisaddress-div").toggleClass('active');
            $("#rebate-payment-cisaddress-div").slideToggle("slow");
        }

        //hide name
        if ($("#rebate-payment-name-div").hasClass('active')) {
            $("#rebate-payment-name-div").toggleClass('active');
            $("#rebate-payment-name-div").slideToggle("slow");
        }

        //hide contractory
        if ($("#rebate-payment-contractor-div").hasClass('active')) {
            $("#rebate-payment-contractor-div").toggleClass('active');
            $("#rebate-payment-contractor-div").slideToggle("slow");
        }
    }

    private static ShowRebateCISAddressOnly() {

        //hide address
        if ($("#rebate-payment-address-div").hasClass('active')) {
            $("#rebate-payment-address-div").toggleClass('active');
            $("#rebate-payment-address-div").slideToggle("slow");
        }

        //show cis address
        if (!$("#rebate-payment-cisaddress-div").hasClass('active')) {
            $("#rebate-payment-cisaddress-div").toggleClass('active');
            $("#rebate-payment-cisaddress-div").slideToggle("slow");
        }

        //hide name
        if ($("#rebate-payment-name-div").hasClass('active')) {
            $("#rebate-payment-name-div").toggleClass('active');
            $("#rebate-payment-name-div").slideToggle("slow");
        }

        //hide contractory
        if ($("#rebate-payment-contractor-div").hasClass('active')) {
            $("#rebate-payment-contractor-div").toggleClass('active');
            $("#rebate-payment-contractor-div").slideToggle("slow");
        }
    }

    private static ShowContractorLookup() {

        //Show contractor
        if (!$("#rebate-payment-contractor-div").hasClass('active')) {
            $("#rebate-payment-contractor-div").toggleClass('active');
            $("#rebate-payment-contractor-div").slideToggle("slow");
        }

        //Hide name
        if ($("#rebate-payment-name-div").hasClass('active')) {
            $("#rebate-payment-name-div").toggleClass('active');
            $("#rebate-payment-name-div").slideToggle("slow");
        }

        //Hide address
        if ($("#rebate-payment-address-div").hasClass('active')) {
            $("#rebate-payment-address-div").toggleClass('active');
            $("#rebate-payment-address-div").slideToggle("slow");
        }

        //Hide CIS address
        if ($("#rebate-payment-cisaddress-div").hasClass('active')) {
            $("#rebate-payment-cisaddress-div").toggleClass('active');
            $("#rebate-payment-cisaddress-div").slideToggle("slow");
        }
    }

    private static ClearRebatePayeeFields() {
        $("#rebate-payment-div").find("input").each(function () {
            $(this).val("");
        });
        $("#rebate-payment-div").find("select").each(function () {
            $(this).val("");
        });
    }

    private static CopyPremiseAddressToPaymentSection() {

        $("#ApplicationInformation_PayeeCompanyName").val($("#ApplicationInformation_CustomerCompanyName").val());
        $("#ApplicationInformation_PayeeFirstName").val($("#ApplicationInformation_CustomerFirstName").val());
        $("#ApplicationInformation_PayeeLastName").val($("#ApplicationInformation_CustomerLastName").val());

        $("#ApplicationInformation_PayeeAddress").val($("#ApplicationInformation_ProjectAddress").val());
        $("#ApplicationInformation_PayeeAddress2").val($("#ApplicationInformation_ProjectAddress2").val());
        $("#ApplicationInformation_PayeeCity").val($("#ApplicationInformation_ProjectCity").val());
        $("#ApplicationInformation_PayeeState").val($("#ApplicationInformation_ProjectState").val());
        $("#ApplicationInformation_PayeeZipCode").val($("#ApplicationInformation_ProjectZipCode").val());
    }

    private static CopyContractorAddressToPaymentSection() {

        if (!$("#ApplicationInformation_PayeeCompanyName").val()) {
            $("#ApplicationInformation_PayeeCompanyName").val($("#ApplicationInformation_ContractorCompanyName").val());
        }
        if (!$("#ApplicationInformation_PayeeFirstName").val()) {
            $("#ApplicationInformation_PayeeFirstName").val($("#ApplicationInformation_ContractorFirstName").val());
        }
        if (!$("#ApplicationInformation_PayeeLastName").val()) {
            $("#ApplicationInformation_PayeeLastName").val($("#ApplicationInformation_ContractorLastName").val());
        }

        if (!$("#ApplicationInformation_PayeeAddress").val()) {
            $("#ApplicationInformation_PayeeAddress").val($("#ApplicationInformation_ContractorAddress").val());
        }
        if (!$("#ApplicationInformation_PayeeAddress2").val()) {
            $("#ApplicationInformation_PayeeAddress2").val($("#ApplicationInformation_ContractorAddress2").val());
        }
        if (!$("#ApplicationInformation_PayeeCity").val()) {
            $("#ApplicationInformation_PayeeCity").val($("#ApplicationInformation_ContractorCity").val());
        }
        if (!$("#ApplicationInformation_PayeeState").val()) {
            $("#ApplicationInformation_PayeeState").val($("#ApplicationInformation_ContractorState").val());
        }
        if (!$("#ApplicationInformation_PayeeZipCode").val()) {
            $("#ApplicationInformation_PayeeZipCode").val($("#ApplicationInformation_ProjectZipCode").val());
        }
    }

    private static EnableDisableRebatePayeeName(enabled) {
        if (enabled == true) {
            $(".rebate-payee-name").prop('disabled', false);

            $(':input.rebate-payee-name').each(function () {
                $(this).rules('add', {
                    required: true,
                    messages: {
                        required: "This field is required."
                    }
                });
            });
        }
        else {
            $(".rebate-payee-name").prop('disabled', true).val('');

            $('input.rebate-payee-name').each(function () {
                $(this).rules('remove', "required");
            });

            $('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').empty();
            $('.input-validation-error').removeClass('input-validation-error').addClass('valid').empty();
        }
    }

    private static EnableDisableRebatePayeeAddress(enabled) {
        if (enabled == true) {
            $(".rebate-payee-addr").prop('disabled', false);

            $(':input.rebate-payee-addr').each(function () {
                $(this).rules('add', {
                    required: true,
                    messages: {
                        required: "This field is required."
                    }
                });
            });

            /*@* Except this guy...* @*/
            $("#ApplicationInformation_PayeeAddress2").rules("remove", "required");
        }
        else {
            $(".rebate-payee-addr").prop('disabled', true).val('');

            $('input.rebate-payee-addr').each(function () {
                $(this).rules('remove', "required");
            });

            $('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid').empty();
            $('.input-validation-error').removeClass('input-validation-error').addClass('valid').empty();
        }
    }

}